export default {
  CONVERSATIONS: {
    CREATE_CONVERSATION: `Créer une conversation`,
    CONVERSATION_LIST: `Vos conversations`,
    SELECT_PARTICIPANTS: `Ajouter des membres`
  },
  CONVO: {
    SEND_MESSAGE: `Envoyer un message`,
    OWNER: `Propriétaire`,
    CUSTOM_NAME: `Nom personnalisé...`,
    IS_TYPING: `est en train d'écrire...`,
    ARE_TYPING: `sont en train d'écrire...`,
    DELETE_CONVERSATION: {
      TITLE: `Supprimer cette conversation`,
      SUMMARY: `Cette action est irréversible, vous ne pourrez pas récupérer la conversation.`,
      PRIMARY_ACTION: `Supprimer la conversation`
    },
    PARTICIPANTS: {
      TITLE: `Membres`,
      ADD: `Add`,
      REMOVE: `Remove`
    },
    MENU: {
      DELETE: `Supprimer`,
      MANAGE: `Gérer les membres`,
      RENAME: `Renommer`
    }
  }
}
